/* eslint-disable comma-dangle */
import { h, Component } from 'preact';
import Theatre from './theatre';
import * as Helper from '../helper';

export default class App extends Component {
	constructor(props) { // eslint-disable-line
		super(props);
		this.state = {
			availableModes: [],
			playerReady: false,
			aspectRatio: 0.5625,
		};
		this.onPlayerLoad = this.onPlayerLoad.bind(this);
		this.communicator = this.communicator.bind(this);
	}

	communicator(event) {
		let cmd;

		try {
			cmd = JSON.parse(event.data);
		}
		catch (e) {}

		if (cmd && cmd.api) {
			switch (cmd.api) {
				case 'playerReady':
					this.onPlayerLoad();
					break;
			}
		}
	}

	onPlayerLoad() {
		this.setState({ playerReady: true });
	}

	componentDidMount() {
		window.addEventListener('message', this.communicator);
		window.addEventListener('resize', () => {
			this.forceUpdate();
		});

		const { videoUUID, bucketID } = Helper.getVideoID();
		const apiCalls = async () => {
			let data;
			const urlParams = Helper.getUrlParams();
			try {
				data = await Helper.getPreviewModes({ videoUUID });
			}
			catch (error) {
				const previewModes = urlParams.modes || '';
				const availableModes = [];
				['desktop', 'interstitial', 'embed'].forEach((mode, idx) => {
					if (previewModes.includes(mode)) {
						availableModes.push(idx + 1);
					}
				});
				this.setState({ availableModes });
			}
			
			const modes = urlParams.modes || '';

			let previewModes = data && data.preview_list && data.preview_list.split(' ').join('');
			previewModes = `${previewModes},${modes}`;
			const availableModes = [];
			['desktop', 'interstitial', 'embed'].forEach((mode, idx) => {
				if (previewModes.includes(mode)) {
					availableModes.push(idx + 1);
				}
			});
			this.setState({ availableModes });
			let aspectRatio;
			if (previewModes.includes('16by9')){
				aspectRatio = 0.5625;
			}
			else {
				// use Datajson to set the aspect-ratio according to skin enable state on the video---
				const datajson = await Helper.getDataJson({ bucketID, videoUUID });
				
				const isSkinEnabled = datajson && datajson.custom && datajson.custom.customskin && datajson.custom.customskin.enableSkin;
				const skinOrientation = isSkinEnabled && datajson && datajson.custom && datajson.custom.customskin && datajson.custom.customskin && datajson.custom.customskin.skinOrientation;
				const isHorizontaSkin = isSkinEnabled && skinOrientation === 'horizontal';
				const isVerticalSkin = isSkinEnabled && skinOrientation !== 'horizontal';
				aspectRatio = isHorizontaSkin ? 0.5625 : isVerticalSkin ? 1.77 : (datajson && datajson.aspect_ratio) || 0.5625;
			}
			this.setState({ aspectRatio });
		}
		apiCalls();
	}
	
	componentWillUnmount() {
		window.removeEventListener('message', this.communicator);
	}

	render() {
		let ismobile = Helper.mobileCheck();
		let islandscape = Helper.landscapeCheck();
		let parentclass = `${ismobile ? 'mobile' : ''} ${islandscape ? 'landscape' : 'portrait'}`;
		return (
			<Theatre
				parentclass={parentclass}
				ismobile={ismobile}
				islandscape={islandscape}
				playerReady={this.state.playerReady}
				availableModes={this.state.availableModes}
				aspectRatio={this.state.aspectRatio}
			/>);
	}
}
 


// WEBPACK FOOTER //
// ./components/app.js